<ul
  class="section-tabs"
  [ngClass]="{ 'section-tabs--bordered-mode': isBorderedMode() }">
  @for (tab of tabs(); track trackByFn($index, tab)) {
    <li
      class="section-tabs__tab-container"
      [ngClass]="{ '!hidden': tab?.hiddenTab }"
      (click)="selectTab(tab)">
      @if (isNavigationMode()) {
        <a
          class="section-tabs__tab"
          [ngClass]="{
            'section-tabs__tab--active': currentFragment === tab?.tabTitle,
          }"
          [routerLink]="currentRoute"
          [fragment]="tab?.tabTitle">
          {{
            translateKey()
              ? (translateKey() + (tab?.tabTitle || '') | translate)
              : tab?.tabTitle
          }}
        </a>
      } @else {
        <p
          class="section-tabs__tab"
          [ngClass]="{
            'section-tabs__tab--active': activeTab === tab?.tabTitle,
          }">
          {{
            translateKey()
              ? (translateKey() + (tab?.tabTitle || '') | translate)
              : tab?.tabTitle
          }}
        </p>
      }

      @if (tab?.tabDataCount || tab?.tabDataCount === '0') {
        <span class="section-tabs__tab-count">
          {{ tab?.tabDataCount || '0' }}
        </span>
      }
    </li>
  }
</ul>
